var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchPad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 163 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LaunchPad"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.162 120.15H78.1623C79.7623 121.35 80.4957 126.984 80.6623 129.65H112.162C110.962 127.65 112.996 122.484 114.162 120.15Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.162 72.6503H76.6623C73.4623 88.6503 75.329 104.984 76.6623 111.15H117.162C119.562 98.3503 117.496 80.1503 116.162 72.6503Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6623 122.65L58.6623 129.65C48.2623 124.05 57.6623 101.65 63.6623 91.1503C60.4623 99.1503 64.9956 115.484 67.6623 122.65Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.162 63.1503H80.6623C79.0623 55.5503 87.329 46.9837 91.6623 43.6503V27.6503C96.0623 22.8503 99.829 25.6503 101.162 27.6503V43.6503C109.162 48.4503 111.829 58.6503 112.162 63.1503Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.162 129.65L123.662 122.65C126.862 124.65 129.329 101.484 130.162 89.6504C141.362 117.65 136.829 127.984 133.162 129.65Z",
    fill: "#135FC2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M44.0188 132H1V151H159.569C163.971 147.2 161.404 140.972 159.569 138.333H44.0188V132Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7",
    d: "M0.5 24C0.5 19.8579 3.85786 16.5 8 16.5H37C41.1421 16.5 44.5 19.8579 44.5 24V46.5H0.5V24Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8",
    d: "M27 73H78V80H27V73Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 0.5,
    y: 56.5,
    width: 44,
    height: 16,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10",
    x: 0.5,
    y: 80.5,
    width: 44,
    height: 16,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 0.5,
    y: 104.5,
    width: 44,
    height: 16,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1912",
    cx: 95,
    cy: 91,
    r: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1913",
    cx: 95,
    cy: 91,
    r: 5,
    fill: "#135FC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchPad);
export default __webpack_public_path__ + "static/media/LaunchPad.1e051132f4e88d83950b402137d3cf24.svg";
export { ForwardRef as ReactComponent };